webpackJsonp([9312377433431],{

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Videos = __webpack_require__(111);
	
	var _Videos2 = _interopRequireDefault(_Videos);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Videos2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction to Lore'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore\'s goal is to simplify the "getting started" journey with React, and to create an experience where you can start building serious applications without knowing anything more than React itself.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To do that, the framework bundles a set of popular libraries (Webpack, Redux, React Router) and configures them with sensible defaults. It also significantly simplifies what is one of the most time consuming parts of React development; writing code to communicate with API servers.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To understand ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'how'
	      ),
	      ' Lore makes it easier to get started with React, the project structure, and the design philosophy behind the framework, check out the video below.'
	    ),
	    _react2.default.createElement(_Video2.default, { videoId: 'QPm6sNKiLok' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-videos-introduction-to-lore-js-e5622b001a06a3802342.js